import Modal from "@/common/elements/Modal";
import AuditLogEntries from "./AuditLogEntries";
import { useEffect } from "react";

const AuditLogEntriesModal = ({ auditLogData, show, onHide }) => {
  useEffect(() => {}, [auditLogData]);

  const onModalHide = () => {
    onHide();
  };

  const onSaveClick = () => {
    onHide();
  };

  return (
    <>
      <Modal
        header="Audit Log Details"
        show={show}
        onHide={onModalHide}
        size="xl"
        footerCloseAction
        footerCloseActionText="Close"
        footerActionsNeed={false}
      >
        <AuditLogEntries auditLogData={auditLogData} />
      </Modal>
    </>
  );
};

export default AuditLogEntriesModal;
